// Kindly's theme choice: the family's System, Light, Dark and High contrast
// (@jkast90/kast-common/theme.css owns the palettes; src/theme.css sets
// Kindly's accent). System, the default for a new user, follows the OS setting
// while the page is open. The shared store keeps the choice under "theme", sets
// <html data-theme>, data-scheme and color-scheme, and follows other tabs; a
// value saved by the old named themes is ignored, so those users start on
// System. index.html runs themeBootScript(themeConfig) before first paint; the
// theme test keeps the two in step. The page colours are the family's, so the
// browser bar takes theirs.

import {
  createThemeStore,
  familyThemeConfig,
  type ThemeConfig,
} from "@jkast90/kast-common/theme";

export const themeConfig: ThemeConfig = {
  storageKey: "theme",
  ...familyThemeConfig({ light: "#f5f7fa", dark: "#080c14" }),
};

export const themeStore = createThemeStore(themeConfig);
